const state = {
  visitedViews: [],
  roleAuthrority: [],
  routerList: [],
  tree1: [], // 成员树（常规）
  tree2: [], // 成员树（停用成员）
  areaContain: {}, // 地区
};

const mutations = {
  ADD_VISITED_VIEW: (state, view) => {
    //如果是相同的路由信息，则返回（结束此方法，不再执行if后面的语句）
    if (state.visitedViews.some((v) => v.path === view.path)) {
      return "";
    }
    state.visitedViews.push(
      Object.assign({}, view, {
        title: view.meta.title || "no-name",
      })
    );
  },
  DEL_VISITED_VIEW: (state, view) => {
    for (const [i, v] of state.visitedViews.entries()) {
      if (v.path === view.path) {
        state.visitedViews.splice(i, 1);
        break;
      }
    }
  },
  // 路由权限XXX
  SS_ROUTER: (state, val) => {
    state.routerList = JSON.parse(JSON.stringify(val));
  },
  // 按钮权限控制
  SET_ROLE_AUTHIRITY: (state, val) => {
    state.roleAuthrority = JSON.parse(JSON.stringify(val));
  },
  // 常规成员树
  SET_TREE1: (state, val) => {
    state.tree1 = JSON.parse(JSON.stringify(val));
  },
  // 停用成员树
  SET_TREE2: (state, val) => {
    state.tree2 = JSON.parse(JSON.stringify(val));
  },
  SET_AREA: (state, val) => {
    state.areaContain = JSON.parse(JSON.stringify(val));
  },
};

const actions = {
  addView({ dispatch }, view) {
    dispatch("addVisitedView", view);
    //dispatch('addCachedView', view)
  },
  addVisitedView({ commit }, view) {
    commit("ADD_VISITED_VIEW", view);
  },
  delView({ dispatch, state }, view) {
    console.log("---");
    return new Promise((resolve) => {
      dispatch("delVisitedView", view);
      //dispatch('delCachedView', view)
      resolve({
        visitedViews: [...state.visitedViews],
        //cachedViews: [...state.cachedViews]
      });
    });
  },
  delVisitedView({ commit, state }, view) {
    return new Promise((resolve) => {
      commit("DEL_VISITED_VIEW", view);
      resolve([...state.visitedViews]);
    });
  },
  setTree1({ commit }, view) {
    commit("SET_TREE1", view);
  },
  setTree2({ commit }, view) {
    commit("SET_TREE2", view);
  },
  setArea({ commit }, view) {
    commit("SET_AREA", view);
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
